import React from 'react';
import QualdoDataTable from '../../../components/bootstrapTable';

/**
 * Isolated catalogue table — skips re-render when parent state changes
 * (modals, toast, etc.) unless table data, selection, or highlight query changes.
 */
class KpiCatalogTable extends React.Component {
    shouldComponentUpdate(nextProps) {
        return (
            nextProps.tableData !== this.props.tableData
            || nextProps.selectedKeys !== this.props.selectedKeys
            || (nextProps.selectedKeys?.size ?? 0) !== (this.props.selectedKeys?.size ?? 0)
            || nextProps.highlightQuery !== this.props.highlightQuery
            || nextProps.entityVersion !== this.props.entityVersion
        );
    }

    render() {
        const {
            tableData,
            customGetActionComponent,
            customHeaderFormatter,
            customRowHighlighter
        } = this.props;

        return (
            <div id="kpi-registry-table-wrapper" className="hide-tbl-border-radius [&_thead_th:last-child]:!tw-text-right">
                <QualdoDataTable
                    id="kpiRegistryTable"
                    component_name="kpiRegistryTable"
                    classNameForTable="table"
                    wrapperClasses="table-responsive action !tw-border-0"
                    data={tableData}
                    hidePagination={true}
                    pageOptions={[15, 25, 50, 100]}
                    paginationSize={999999}
                    selectionCount={this.props.selectedKeys?.size ?? 0}
                    customGetActionComponent={customGetActionComponent}
                    customHeaderFormatter={customHeaderFormatter}
                    customRowHighlighter={customRowHighlighter}
                />
            </div>
        );
    }
}

export default KpiCatalogTable;
